import React from 'react'
import { Phone, Mail } from 'lucide-react'

export default function TopNav() {
  return (
    <div className="w-full bg-muted py-2 border-b border-gray-200">
      <div className="container mx-auto px-4 flex items-center justify-between">
        <div>
          <img
            src="./mexico-flag.png"
            alt="Bandera de México"
            className="h-6 w-auto"
          />
        </div>
        <div className="flex items-center gap-2 md:gap-4">
          <a href="tel:+525530555118" className="flex items-center gap-1 md:gap-2 text-xs md:text-sm text-muted-foreground hover:text-primary whitespace-nowrap">
            <Phone size={14} className="text-[#b7221c]" />
            <span className="hidden sm:inline">55 3051 4361</span>
            <span className="sm:hidden">55 3051 4361</span>
          </a>
          <a href="mailto:contacto@guerecabogados.com" className="flex items-center gap-1 md:gap-2 text-xs md:text-sm text-muted-foreground hover:text-primary whitespace-nowrap">
            <Mail size={14} className="text-[#b7221c]" />
            <span className="hidden sm:inline">contacto@guerecabogados.com</span>
            <span className="sm:hidden">contacto@uerecabogados.com</span>
          </a>
        </div>
      </div>
    </div>
  )
}
